export const PASSWORD_MISMATCH_ERROR = "Les mots de passe sont différents";
export const PASSWORD_STRENGTH_ERROR = "PASSWORD_STRENGTH_ERROR";

export const isPasswordValidationError = (message: string) =>
  message === PASSWORD_MISMATCH_ERROR || message === PASSWORD_STRENGTH_ERROR;

export const isPasswordStrong = (value: string) => {
  const hasMinLength = value.length >= 8;
  const hasUppercase = /[A-Z]/.test(value);
  const hasLowercase = /[a-z]/.test(value);
  const hasNumber = /\d/.test(value);
  const hasSpecialChar = /[!@#$%^&*\-_.]/.test(value);
  return (
    hasMinLength &&
    hasUppercase &&
    hasLowercase &&
    hasNumber &&
    hasSpecialChar
  );
};

export const isPasswordFormReady = (
  password: string,
  passwordConfirm: string
) =>
  password.trim() !== "" &&
  passwordConfirm.trim() !== "" &&
  isPasswordStrong(password) &&
  password === passwordConfirm;
